<!-- <link href="assets/vendor/datatables/dataTables.bootstrap4.min.css" rel="stylesheet"> -->
<div *ngIf="spinner==true">
  <ngx-spinner  size="medium"  type="timer" >
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div>


<div class="container-fluid">
  <div class="card shadow">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py">REQUEST OFFICE BEARER ROLE CHANGES</h4>

        <!-- <div style="width:200px">
          <button  type="button" class="btn btn-block btn-danger" data-toggle="modal" data-target="#addtionalroleDialog" >Additional Post Request</button>
        </div> -->
        
      </div>
    </div>
    <div *ngIf="!tableshow" style="margin-left: 50%;">
      <div *ngIf="customers.length == 0" class="loader"></div>
    </div>
      <!-- <div class="modal fade" id="modal-xl">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="card-danger">
                  <div class="card-header">
                    <h3 class="card-title">Edit Office Bearer Information</h3>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="card-body">
                    <form [formGroup]='editform' (ngSubmit)="updatedata(editform)" autocomplete="off">
                        <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>First Name/முதல் பெயர்</label>
                                <input type="text" name="firstname1" formControlName="firstname1" class="form-control"  placeholder="Enter First Name/முதல் பெயர்"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Last Name/குடும்ப பெயர்</label>
                                <input type="text" name="lastname1" formControlName="lastname1" class="form-control"  placeholder="Enter Last Name/குடும்ப பெயர்"/>
                              </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Age / வயது</label>
                              <input type="number" name="age1" class="form-control"  min="18" max="100" placeholder="Enter Age / வயது" formControlName="age1" />
                            </div>
                            <div class="col-sm-6">
                              <label>Date of Birth</label>
                              <input type="date" name="date_of_birth1" class="form-control"  placeholder="Enter Date of Birth" formControlName="date_of_birth1"/>
                            </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Father Name / தந்தையின் பெயர்</label>
                              <input type="text" name="father_name1" class="form-control"  placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="father_name1"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Mother Name / தாய் பெயர்</label>
                              <input type="text" name="mother_name1" class="form-control"  placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name1"/>
                            </div>
                      </div>
                      <div class="form-group row">
                          <div class="col-6 md:col-6">
                            <label>Degree / கல்வித் தகுதி</label>
                            <input type="text" name="educational_qualification1" formControlName="educational_qualification1" class="form-control"  placeholder="Enter Degree / கல்வித் தகுதி"/>
                          </div>
                          <div class="col-6 md:col-6">
                            <label>Additional Degree / சிறப்பு தகுதி</label>
                          <input type="text" name="additional_qualification" formControlName="additional_qualification1" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி"/>
                          </div>
                      </div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Phone Number / தொலைபேசி எண்</label>
                                <input type="text" name="contact_no1" formControlName="contact_no1" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" />
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Whatsapp Number /வாட்ஸ்அப் எண்</label>
                                <input type="text" name="whatsapp_no" formControlName="whatsapp_no1" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" />
                              </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Email/மின்னஞ்சல்</label>
                              <input type="text" name="email1" formControlName="email1" class="form-control"  placeholder="Enter Email/மின்னஞ்சல்" />
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Profession / தொழில்,வேலை</label>
                              <input pInputText type="text" class="form-control" name="profession1" formControlName="profession1"  placeholder="Enter Profession / தொழில்,வேலை" />
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Address / முகவரி</label>
                              <textarea name="address1" formControlName="address1" pInputText class="form-control"  placeholder="Enter Address / முகவரி" cols="100" rows="5"></textarea>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-12 md:col-12">
                                <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                <select name="applied_role" formControlName="applied_role1"  class="form-control">
                                    <option value="">Select Option</option>
                                    <option value="Village Deputy Organiser">District President / மாவட்ட தலைவர்</option>
                                    <option value="Village Deputy Organiser">District Vice President / மாவட்ட துணை தலைவர்</option>
                                    <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                    <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                    <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                    <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                    <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                    <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                    <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                    <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                    <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                    <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                </select>
                            </div>
                      </div>
                      <div class="form-group">
                          <div class="col-sm-6">
                            <label>Comments</label>
                            <textarea name="party_comments1" formControlName="party_comments1" pInputText class="form-control"  placeholder="Enter Comments" cols="100" rows="5" ></textarea>
                          </div>
                          <div class="col-sm-6">
                          <label>District</label>
                          <textarea name="party_comments1" formControlName="party_comments1" pInputText class="form-control"  placeholder="Enter Comments" cols="100" rows="5" ></textarea>
                        </div> -->
                      <!-- </div>
                      <div class="col-3" style="margin-left:34%;">
                          <button  class="btn btn-danger btn btn-block">
                            UPDATE OFFICE BEARER
                          </button>
                        </div>
                      </form>
                  </div>
             </div>
          </div> -->
          <!-- /.modal-content -->
        <!-- </div> -->
        <!-- /.modal-dialog -->
      <!-- </div>  -->
      <!-- /.modal -->

      <!-- <div class="modal fade" id="showDialog">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="card-danger">
                  <div class="card-header">
                    <h3 class="card-title">Office Bearer Information (Non-Editable)</h3>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="card-body">
                    <form>
                        <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>First Name/முதல் பெயர்</label>
                                <input type="text" class="form-control" [disabled]="true" placeholder="Enter First Name/முதல் பெயர்" [value]="OBname"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Last Name/குடும்ப பெயர்</label>
                                <input type="text" name="lastname" class="form-control" [disabled]="true" placeholder="Enter Last Name/குடும்ப பெயர்" [value]="OBlastname"/>
                              </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Age / வயது</label>
                              <input type="number" name="age" class="form-control" [disabled]="true" min="18" max="100" placeholder="Enter Age / வயது"[value]="OBage"/>
                            </div>
                            <div class="col-sm-6">
                              <label>Date of Birth</label>
                              <input type="date" name="date_of_birth"class="form-control" [disabled]="true" placeholder="Enter Date of Birth"[value]="OBdateofbirth"/>
                            </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Father Name / தந்தையின் பெயர்</label>
                              <input type="text" name="father_name" class="form-control" [disabled]="true" placeholder="Enter Father Name / தந்தையின் பெயர்" [value]="OBfathername"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Mother Name / தாய் பெயர்</label>
                              <input type="text" name="mother_name1" class="form-control" [disabled]="true" placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name1" [value]="OBfathername"/>
                            </div>
                      </div>
                      <div class="form-group row">
                          <div class="col-6 md:col-6">
                            <label>Degree / கல்வித் தகுதி</label>
                            <input type="text" name="educational_qualification" class="form-control" [disabled]="true" placeholder="Enter Degree / கல்வித் தகுதி"[value]="OBdegree"/>
                          </div>
                          <div class="col-6 md:col-6">
                            <label>Additional Degree / சிறப்பு தகுதி</label>
                          <input type="text" name="additional_qualification" class="form-control" [disabled]="true" placeholder="Enter Additional Degree / சிறப்பு தகுதி"[value]="OBaddtionaldegree"/>
                          </div>
                      </div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Phone Number / தொலைபேசி எண்</label>
                                <input type="text" name="contact_no" class="form-control" [disabled]="true" placeholder="Enter Phone Number / தொலைபேசி எண்"[value]="OBphonenumber"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Whatsapp Number /வாட்ஸ்அப் எண்</label>
                                <input type="text" name="whatsapp_no" class="form-control" [disabled]="true" placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்"[value]="whatsappnumner"/>
                              </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Email/மின்னஞ்சல்</label>
                              <input type="text" name="email" class="form-control" [disabled]="true" placeholder="Enter Email/மின்னஞ்சல்"[value]="OBmail"/>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Profession / தொழில்,வேலை</label>
                              <input pInputText type="text" class="form-control" name="profession" [disabled]="true" placeholder="Enter Profession / தொழில்,வேலை"[value]="OBprofession"/>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Address / முகவரி</label>
                              <textarea name="address1" pInputText class="form-control"  [disabled]="true" placeholder="Enter Address / முகவரி" cols="100" rows="5" [value]="OBaddress"></textarea>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-12 md:col-12">
                                <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                <select name="applied_role"  class="form-control" [disabled]="true" [value]="OBold_designation">
                                    <option value="">Select Option</option>
                                    <option value="Village Deputy Organiser">District President / மாவட்ட தலைவர்</option>
                                    <option value="Village Deputy Organiser">District Vice President / மாவட்ட துணை தலைவர்</option>
                                    <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                    <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                    <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                    <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                    <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                    <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                    <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                    <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                    <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                    <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                </select>
                            </div>
                      </div>
                      <div class="form-group">
                          <div class="col-sm-6">
                            <label>Comments</label>
                            <textarea name="party_comments" pInputText class="form-control" [disabled]="true" placeholder="Enter Comments" cols="100" rows="5" [value]="OBcomments"></textarea>
                          </div>
                      </div>
                       <div class="col-3" style="margin-left:34%;">
                          <a  class="btn btn-danger btn btn-block">
                            UPDATE OFFICE BEARER
                          </a>
                        </div> -->
                      <!-- </form>
                  </div>
             </div>
          </div> -->
          <!-- /.modal-content -->
        <!-- </div> -->
        <!-- /.modal-dialog -->
      <!-- </div>  -->






            <!-- <div class="modal fade" id="myModal">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="card-danger">
                    <div class="card-header">
                      <h3 class="card-title">Create office bearer</h3>
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="card-body">
                      <form  [formGroup]='officebearerform' (ngSubmit)="postdata(officebearerform)" autocomplete="off">
                          <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>

                        <div class="form-group row">
                                <div class="col-6 md:col-6">
                                  <label>First Name/முதல் பெயர்</label><span class="required "> *</span>
                                  <input type="text" name="firstname" class="form-control"  placeholder="Enter First Name/முதல் பெயர்" formControlName="firstname"/>
                                  <div  *ngIf="officebearerform.get('firstname').hasError('required') && officebearerform.get('firstname').touched"
                                    class="invalid-msg">Please enter the valid field
                                </div>
                                <div *ngIf="officebearerform.get('firstname').hasError('pattern') && officebearerform.get('firstname').touched"
                                    class="invalid-msg">Please enter the valid Name
                              </div>
                              <div *ngIf="officebearerform.get('firstname').hasError('required')"
                              class="invalid-msg" [hidden]='hidden'>Please enter the Firstname
                            </div>
                                </div>
                                <div class="col-6 md:col-6">
                                  <label>Last Name/குடும்ப பெயர்</label><span class="required "> *</span>
                                  <input type="text" name="lastname" class="form-control"  placeholder="Enter Last Name/குடும்ப பெயர்" formControlName="lastname"/>
                                  <div *ngIf="officebearerform.get('lastname').hasError('required') && officebearerform.get('lastname').touched"
                                    class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div *ngIf="officebearerform.get('lastname').hasError('pattern') && officebearerform.get('lastname').touched"
                                    class="invalid-msg">Please enter the valid Name
                                  </div>
                                  <div *ngIf="officebearerform.get('lastname').hasError('required')"
                                  class="invalid-msg" [hidden]='hidden'>Please enter the Lastname
                                </div>
                                </div>
                        </div>
                        <div class="form-group row">
                          <div class="col-sm-6">
                                <label>Date of Birth</label><span class="required "> *</span>
                                <input type="date" name="date_of_birth"class="form-control"  placeholder="Enter Date of Birth" [(ngModel)]="date_of_birth" (ngModelChange)="calculateAge()" formControlName="date_of_birth"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Age / வயது</label><span class="required "> *</span>
                                <input type="number" name="age" class="form-control age" [(ngModel)]="age"  min="18" max="100" placeholder="Enter Age / வயது" formControlName="age" readonly/>
                              </div>
                        </div>
                        <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Father Name / தந்தையின் பெயர்</label><span class="required "> *</span>
                                <input type="text" name="father_name" class="form-control"  placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="father_name"/>
                                <div *ngIf="officebearerform.get('father_name').hasError('required') && officebearerform.get('father_name').touched"
                                    class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div *ngIf="officebearerform.get('father_name').hasError('pattern') && officebearerform.get('father_name').touched"
                                    class="invalid-msg">Please enter the valid Name
                                  </div>
                                  <div *ngIf="officebearerform.get('father_name').hasError('required')"
                                    class="invalid-msg" [hidden]='hidden'>Please enter the Father Name
                                  </div>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Mother Name / தாய் பெயர்</label>
                                <input type="text" name="mother_name" class="form-control"  placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name"/>
                              </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Degree / கல்வித் தகுதி</label><span class="required "> *</span>
                              <input type="text" name="educational_qualification" class="form-control"  placeholder="Enter Degree / கல்வித் தகுதி" formControlName="educational_qualification"/>
                              <div *ngIf="officebearerform.get('educational_qualification').hasError('required')"
                                    class="invalid-msg" [hidden]='hidden'>Please enter the degree
                                  </div>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Additional Degree / சிறப்பு தகுதி</label>
                            <input type="text" name="additional_qualification" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி" formControlName="additional_qualification"/>
                            </div>
                        </div>

                        <div class="form-group row">
                                <div class="col-6 md:col-6">
                                  <label>Phone Number / தொலைபேசி எண்</label><span class="required "> *</span>
                                  <input type="text" name="contact_no" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" formControlName="contact_no"/>
                                  <div *ngIf="officebearerform.get('contact_no').hasError('required') && officebearerform.get('contact_no').touched"
                                    class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div  *ngIf="officebearerform.get('contact_no').hasError('pattern') && officebearerform.get('contact_no').touched"
                                    class="invalid-msg">Please enter the valid Phone Number
                                  </div>
                                  <div *ngIf="officebearerform.get('contact_no').hasError('required')"
                                    class="invalid-msg" [hidden]='hidden'>Please enter the Contact Number
                                  </div>
                                </div>
                                <div class="col-6 md:col-6">
                                  <label>Whatsapp Number /வாட்ஸ்அப் எண்</label><span class="required "> *</span>
                                  <input type="text" name="whatsapp_no" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" formControlName="whatsapp_no"/>
                                  <div *ngIf="officebearerform.get('whatsapp_no').hasError('required') && officebearerform.get('whatsapp_no').touched"
                                     class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div *ngIf="officebearerform.get('whatsapp_no').hasError('pattern') && officebearerform.get('whatsapp_no').touched"
                                    class="invalid-msg">Please enter the valid Whatsapp Number
                                  </div>
                                  <div *ngIf="officebearerform.get('whatsapp_no').hasError('required')"
                                    class="invalid-msg" [hidden]='hidden'>Please enter the Whatsapp Number
                                  </div>
                                </div>
                        </div>
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Email/மின்னஞ்சல்</label><span class="required "> *</span>
                                <input type="text" name="email" class="form-control"  placeholder="Enter Email/மின்னஞ்சல்" formControlName="email"/>
                                 <div *ngIf="officebearerform.get('email').hasError('required') && officebearerform.get('email').touched"
                                   class="invalid-msg">Please enter the valid field
                                  </div>
                                 <div *ngIf="officebearerform.get('email').hasError('pattern') && officebearerform.get('email').touched"
                                  class="invalid-msg">Please enter the valid Email Id
                                </div>
                                <div *ngIf="officebearerform.get('email').hasError('required')"
                                    class="invalid-msg" [hidden]='hidden'>Please enter the Email
                                  </div>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Profession / தொழில்,வேலை</label>
                                <input pInputText type="text" class="form-control" name="profession"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession"/>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Address / முகவரி</label>
                                <textarea name="address1" pInputText class="form-control"  placeholder="Enter Address / முகவரி" cols="100" rows="5" formControlName="address1"></textarea>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-12 md:col-12">
                                  <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                  <select name="applied_role"  class="form-control" formControlName="applied_role">
                                      <option value="">Select Option</option>
                                      <option value="Village Deputy Organiser">District President / மாவட்ட தலைவர்</option>
                                      <option value="Village Deputy Organiser">District Vice President / மாவட்ட துணை தலைவர்</option>
                                      <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                      <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                      <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                      <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                      <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                      <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                      <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                      <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                      <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                      <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                  </select>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-6">
                              <label>Comments</label>
                              <textarea name="party_comments" pInputText class="form-control"  placeholder="Enter Comments" cols="100" rows="5" formControlName="party_comments"></textarea>
                            </div>
                            <div class="col-6 md:col-6">
                              <input  type="text" hidden  formControlName="mode"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <input type="text" hidden  formControlName="location_id"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="mode" formControlName="mode"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="location_id" formControlName="location_id"/>
                            </div>
                        </div> -->
                          <!-- <div class="col-3" style="margin-left:34%;">
                            <button class="btn btn-danger btn btn-block">Create office bearer</button>
                          </div>
                        </form>
                    </div>
                  </div>
                </div>
              </div>
            </div> --> 


<!-- OFFICE BEARER DATATABLE         -->
<div class="card-body">
  <div class="table-responsive" *ngIf="tableshow">
      <!-- TABLE -->
          <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                  <th>Name</th>
                  <!-- <th>Designation</th> -->
                  
                  <!-- <th>Status</th> -->
                  <th>Email</th>
                  <th>Contact no</th>
                  <th>Applied role</th>
                  <th [hidden]="isButtonDisabled">Request</th>
                  

              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let customer of customers">
                <td style="min-width: 20px;">
                  {{customer.name}}
                  </td>
                  <!-- <td style="min-width: 20px;">
                  {{customer.designation}}
                  </td> -->
                  
                  <!-- <td style="min-width: 20px;">
                  {{customer.approval_status}}
                  </td> -->
                  <td style="min-width: 20px;">
                  {{customer.email}}
                  </td>
                  <td style="min-width: 20px;">
                    {{customer.contact_no}}
                    </td>
                    <td style="min-width: 20px;">
                      {{customer.applied_role}}
                      </td>
                  <td [hidden]="isButtonDisabled">
                    <div *ngIf="customer.role_change_status == ''" >
                      <button data-toggle="modal" data-target="#requestDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer) ;getPostingDropdown(customer.applied_posting)">
                        <i class="fas fa-flag"></i>
                    </button>
                    </div>
                  
                  <div *ngIf="customer.role_change_status == 'approved'">
                    <button data-toggle="modal" data-target="#requestDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer);getPostingDropdown(customer.applied_posting)">
                      <i class="fas fa-flag"></i>
                  </button>
                  </div>
                  <div *ngIf="customer.role_change_status == 'pending'">
                    <button disabled data-toggle="modal" data-target="#requestDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer)">
                      <i class="fas fa-flag"></i>
                  </button>
                  </div>
                  <div *ngIf="customer.role_change_status == 'rejected'">
                    <button data-toggle="modal" data-target="#requestDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer);getPostingDropdown(customer.applied_posting)">
                      <i class="fas fa-flag"></i>
                  </button>
                  </div>
                </td>
                </tr>
            </tbody>

          </table>
  </div>
</div>

</div>

</div>

<!-- role change -->
<div class="modal fade" id="requestDialog">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="card-danger">
        <div class="card-header">
          <h3 class="card-title">Request office bearer</h3>
          <button type="button" class="close" data-dismiss="modal" (click)="FormReset()">&times;</button>
        </div>
        <div class="card-body">

           <form class="request-form" [formGroup]='reqform' (ngSubmit)="postdata1(reqform)" autocomplete="off">
            <div class="form-group">
                <div class="col-6 md:col-6">
                  <input type="text" pInputText  hidden name="user_id" formControlName="user_id" [value]="OBid"
                    placeholder="obid" />

                </div>
              </div>
            <div class="form-group">
             <div class="col-12 md:col-12">
                                  <label>First Name</label><span class="required "> *</span>
                                  <input  pInputText type="text" name="name" class="form-control" [disabled]="true"  placeholder="Enter Name" [value]="OBname+OBlastname" />
                                  <div  *ngIf="reqform.get('name').hasError('required') && reqform.get('name').touched"
                                    class="invalid-msg">Please enter the valid field
                                </div>
                </div>

            </div>
            <!-- </div> -->
            <div class="form-group">
              <div class="col-12 md:col-12">
                                   <label>Email</label><span class="required "> *</span>
                                   <input  pInputText type="text" name="email1" class="form-control" [disabled]="true" placeholder="Email"  [value]="OBmail"/>
                                   <div  *ngIf="reqform.get('email1').hasError('email') && reqform.get('email1').touched"
                                     class="invalid-msg">Please enter the valid field
                                 </div>
                 </div>

             </div>
             <div class="form-group">
              <div class="col-12 md:col-12">
                <label>மாவட்டம் / மாநகரம் / ஒன்றியம் / நகரம் / பகுதி / பேரூர் 
                  <span class="required "> *</span></label><br>
                <select name="applied_posting" class="form-control" [disabled]="true" [value]="OBapplied_posting">
                  <option value="" disabled selected hidden>Select Option</option>

                  <option value="மாவட்டம்">மாவட்டம்</option>
                  <option value="மாநகரம்">மாநகரம்</option>
                  <option value="ஒன்றியம்">ஒன்றியம்</option>
                  <option value="நகரம்">நகரம்</option>
                  <option value="பகுதி">பகுதி</option>
                  <option value="பேரூர்">பேரூர்</option>

                </select>


              </div></div>
            <div class="form-group">
              <div class="col-12 md:col-12">
                                   <label>Old Designation</label><span class="required "> *</span>
                                   <input  pInputText type="text" name="old_designation" class="form-control" [disabled]="true" placeholder="Old Designation"   [value]="OBold_designation" />
                                   <!-- <div  *ngIf="reqform.get('old_designation').hasError('old_designation') && reqform.get('old_designation').touched"
                                     class="invalid-msg">Please enter the valid field
                                 </div> -->
                 </div>

             </div>
          

            <!-- <div class="form-group ">
                <div class="col-12 md:col-12">
                  <label>New Designation</label><span class="required "> *</span>

                    <select name="new_designation1" formControlName="new_designation1"  class="form-control" placeholder="New Designation">
                      <option value="">Select Option</option>
                      <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                      <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                      <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                      <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                      <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                      <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                      <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                      <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                      <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                      <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                  </select>
                      <div  *ngIf="reqform.get('new_designation1').hasError('new_designation1') && reqform.get('new_designation1').untouched "
                    class="invalid-msg">Please enter the valid field
                  </div>  -->
                  <!-- reqform.get('new_designation1').touched -->
                  <!-- <div  *ngIf="reqform.get('new_designation1').hasError('required') "
                  class="invalid-msg" >Please select this field</div> -->
                  <!-- <div  class="invalid-msg" *ngIf="reqform.get('new_designation1').touched && new_designation1.value ==''" >Please select this field</div>
                  <div  class="invalid-msg" *ngIf="reqform.get('new_designation1').untouched" [hidden]='hidden'>Please select this field</div>
                </div>
            </div> --> 
            <div class="form-group ">
              <div class="col-12 md:col-12">
            
              <label>New Designation</label><span class="required "> *</span>
              <select name="new_designation1" class="form-control" formControlName="new_designation1" (click)="nopost_msg()">
                <option value="" selected disabled hidden>Select Option</option>
                <option *ngFor="let option of dropdown_list" (value)="option" >
                  {{option}}</option>
                <!-- <option *ngIf="applied_posting111=='true'" value="மாவட்ட தலைவர்">மாவட்ட தலைவர்</option>
                <option *ngIf="applied_posting112=='true'" value="மாவட்ட துணை தலைவர்">மாவட்ட துணைத் தலைவர்</option>
                <option *ngIf="applied_posting113=='true'" value="மாவட்ட அமைப்பாளர்">மாவட்ட அமைப்பாளர்</option>
                <option *ngIf="applied_posting114=='true'" value="மாவட்ட துணை அமைப்பாளர் 1">மாவட்ட துணை அமைப்பாளர்
                  1</option>
                <option *ngIf="applied_posting115=='true'" value="மாவட்ட துணை அமைப்பாளர் 2">மாவட்ட துணை அமைப்பாளர்
                  2</option>
                <option *ngIf="applied_posting116=='true'" value="மாவட்ட துணை அமைப்பாளர் 3">மாவட்ட துணை அமைப்பாளர்
                  3</option>
                <option *ngIf="applied_posting117=='true'" value="மாவட்ட துணை அமைப்பாளர் 4">மாவட்ட துணை அமைப்பாளர்
                  4</option>
                <option *ngIf="applied_posting118=='true'" value="மாவட்ட துணை அமைப்பாளர் 5">மாவட்ட துணை அமைப்பாளர்
                  5</option>
                 

                <option *ngIf="applied_posting119=='true'" value="மாநகர அமைப்பாளர்">மாநகர அமைப்பாளர்</option>
                <option *ngIf="applied_posting120=='true'" value="மாநகர துணை அமைப்பாளர் 1">மாநகர துணை அமைப்பாளர் 1
                </option>
                <option *ngIf="applied_posting121=='true'" value="மாநகர துணை அமைப்பாளர் 2">மாநகர துணை அமைப்பாளர் 2
                </option>
                <option *ngIf="applied_posting122=='true'" value="மாநகர துணை அமைப்பாளர் 3">மாநகர துணை அமைப்பாளர் 3
                </option>
                <option *ngIf="applied_posting123=='true'" value="மாநகர துணை அமைப்பாளர் 4">மாநகர துணை அமைப்பாளர் 4
                </option>
                <option *ngIf="applied_posting124=='true'" value="மாநகர துணை அமைப்பாளர் 5">மாநகர துணை அமைப்பாளர் 5
                </option>



                <option *ngIf="applied_posting125=='true'" value="ஒன்றிய அமைப்பாளர்">ஒன்றிய அமைப்பாளர்</option>
                <option *ngIf="applied_posting126=='true'" value="ஒன்றிய துணை அமைப்பாளர் 1">ஒன்றிய துணை அமைப்பாளர்
                  1</option>
                <option *ngIf="applied_posting127=='true'" value="ஒன்றிய துணை அமைப்பாளர் 2">ஒன்றிய துணை அமைப்பாளர்
                  2</option>
                <option *ngIf="applied_posting128=='true'" value="ஒன்றிய துணை அமைப்பாளர் 3">ஒன்றிய துணை அமைப்பாளர்
                  3</option>





                <option *ngIf="applied_posting129=='true'" value="நகர அமைப்பாளார்">நகர அமைப்பாளார்</option>
                <option *ngIf="applied_posting130=='true'" value="நகர துணை அமைப்பாளர் 1">நகர துணை அமைப்பாளர் 1
                </option>
                <option *ngIf="applied_posting131=='true'" value="நகர துணை அமைப்பாளர் 2">நகர துணை அமைப்பாளர் 2
                </option>
                <option *ngIf="applied_posting132=='true'" value="நகர துணை அமைப்பாளர் 3">நகர துணை அமைப்பாளர் 3
                </option>

                <option *ngIf="applied_posting133=='true'" value="பகுதி அமைப்பாளர்">பகுதி அமைப்பாளர்</option>
                <option *ngIf="applied_posting134=='true'" value="பகுதி துணை அமைப்பாளர் 1">பகுதி துணை அமைப்பாளர் 1
                </option>
                <option *ngIf="applied_posting135=='true'" value="பகுதி துணை அமைப்பாளர் 2">பகுதி துணை அமைப்பாளர் 2
                </option>
                <option *ngIf="applied_posting136=='true'" value="பகுதி துணை அமைப்பாளர் 3">பகுதி துணை அமைப்பாளர் 3
                </option>

                <option *ngIf="applied_posting137=='true'" value="பேரூர் அமைப்பாளர்">பேரூர் அமைப்பாளர்</option>
                <option *ngIf="applied_posting138=='true'" value="பேரூர் துணை அமைப்பாளர்">பேரூர் துணை அமைப்பாளர் 1</option>
                <option *ngIf="applied_posting139=='true'" value="பேரூர் துணை அமைப்பாளர்">பேரூர் துணை அமைப்பாளர் 2</option>
                <option *ngIf="applied_posting140=='true'" value="பேரூர் துணை அமைப்பாளர்">பேரூர் துணை அமைப்பாளர் 3</option> -->
                <!-- <option *ngIf="(applied_posting111 =='false' && applied_posting112  =='false'&& applied_posting113 =='false' &&applied_posting114  =='false' && applied_posting115 =='false' && applied_posting116 =='false' && applied_posting117 =='false' && applied_posting118 =='false'
                && applied_posting119=='false' && applied_posting120 =='false' && applied_posting121  =='false'&& applied_posting122 =='false' && applied_posting123 =='false' && applied_posting124 =='false' && applied_posting125 =='false' && applied_posting126 =='false' && applied_posting127 =='false'
                 && applied_posting128=='false'&& applied_posting129 =='false' && applied_posting130 =='false' && applied_posting131 =='false' && applied_posting132 =='false' && applied_posting133 =='false' && applied_posting134 =='false' && applied_posting135  =='false'&& applied_posting136  =='false'
                  && applied_posting137=='false' && applied_posting138=='false')  " value="">>It seems all the posts for this district has been filled. You cannot create Office bearer for this district.
                  </option> -->
              </select>

              <div *ngIf="reqform.get('new_designation1').hasError('required')" class="invalid-msg"
                [hidden]='hidden'>Please fill out this field  </div>
                <div class="invalid-msg"
                *ngIf="dropdown_list=='' && nopost_Error_msg==true">It seems all the posts for this district has been filled. Please contact administrator.
               </div>
            </div>

            <div class="form-group ">
                <div class="col-12 md:col-12">
                  <label>Reason</label><span class="required "> *</span>
                    <input pInputText type="text" name="reason"  class="form-control" formControlName="reason" placeholder="Reason" >
                    <div  *ngIf="reqform.get('reason').hasError('reason')"
                    class="invalid-msg">Please enter the valid field
                  </div>
                  <div  class="invalid-msg" *ngIf="reqform.get('reason').hasError('required')" [hidden]='hidden'>Please select this field</div>
                </div>
              </div>
                <div class="col-12 md:col-12" hidden>
                  <label>District</label><span class="required "> *</span>
                    <input pInputText type="text" name="district"  class="form-control" formControlName="district" placeholder="District "  [value]="OBDistrict">
                  
                </div>
            
                <div _ngcontent-qih-c35="" class="col-8 mx-auto"><button _ngcontent-qih-c35="" class="btn btn-danger btn btn-block"> Request Designation Change </button></div>


            </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- addtional role request -->
<div class="modal fade" id="addtionalroleDialog">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div *ngIf="PreviousAdd_PostReq.length==0;else elsetemplate">
        <div class="card-danger">
            <div class="card-header">
                <h3 class="card-title">Request Addtional Post</h3>
                <button type="button" class="close" data-dismiss="modal" (click)="FormReset()">&times;</button>
              </div>
              <div class="card-body">
                <form class="request-form" [formGroup]='add_roleform' (ngSubmit)="additionalRoleRequest(add_roleform)" autocomplete="off">
                  <!-- <div class="form-group">
                  <div class="col-12 md:col-12" hidden>
                                        <label>District Admin Name</label><span class="required "> *</span>
                                        <input  pInputText type="text" name="name" class="form-control"   formControlName="da_name" placeholder="Enter Name" />
                                        <div  *ngIf="reqform.get('name').hasError('required') && reqform.get('name').touched"
                                          class="invalid-msg">Please enter the valid field
                                        </div>
                  </div>
                  </div> -->
                  
                  <div class="form-group">
                    <div class="col-12 md:col-12">
                                        <label>District Name</label><span class="required "> *</span>
                                        <input  pInputText type="text" name="email1" class="form-control" formControlName="da_district_name" placeholder="Email" readonly/>
                                        <!-- <div  *ngIf="reqform.get('email1').hasError('email') && reqform.get('email1').touched"
                                          class="invalid-msg">Please enter the valid field
                                        </div> -->
                    </div>

                  </div>
                  <div class="form-group">
                    <div class="col-12 md:col-12">
                      <label>மாவட்டம் / மாநகரம் / ஒன்றியம் / நகரம் / பகுதி / பேரூர்
                        <span class="required "> *</span></label><br>
                      <select name="applied_posting" class="form-control"  formControlName="district_catagory">
                        <option value="" disabled selected hidden>Select Option</option>
                        <option value="மாவட்டம்">மாவட்டம்</option>
                        <option value="மாநகரம்">மாநகரம்</option>
                        <option value="ஒன்றியம்">ஒன்றியம்</option>
                        <option value="நகரம்">நகரம்</option>
                        <option value="பகுதி">பகுதி</option>
                        <option value="பேரூர்">பேரூர்</option>
                      </select>
                      <div  *ngIf="district_catagory.errors?.['required'] && district_catagory.untouched==false"
                                class="invalid-msg" [hidden]="!hidden">Please select this field
                      </div>
                      <div  *ngIf="district_catagory.invalid" [hidden]="hidden"
                                class="invalid-msg">Please select this field
                      </div>
                    
                    </div>
                  </div>
                  
                    <div class="form-group ">
                      <div class="col-12 md:col-12">
                        <label>Requesting Role Name</label><span class="required "> *</span>
                          <input pInputText type="text" name="reason"  class="form-control" formControlName="role_name" placeholder="Reason" readonly>
                          <!-- <div  *ngIf="reqform.get('reason').hasError('reason') && reqform.get('reason').touched"
                          class="invalid-msg">Please enter the valid field
                          </div> -->
                        <!-- <div  class="invalid-msg" *ngIf="reqform.get('reason').untouched" [hidden]='hidden'>Please select this field</div> -->
                      </div>
                    </div>
                      
                      <div _ngcontent-qih-c35="" class="col-8 mx-auto"><button _ngcontent-qih-c35="" class="btn btn-danger btn btn-block"> Request Addtional Post </button>
                      </div>

                </form>
              </div>
        </div>
      </div>
      <ng-template #elsetemplate >
        <div *ngIf="PreviousAdd_PostReq.length !=0" class="card-danger">
          <div class="card-header">
              <h3 class="card-title"></h3>
              <button type="button" class="close" data-dismiss="modal" (click)="FormReset()">&times;</button>
          </div>
          <div class="card-body">
            <div style="text-align: center;">
              <h5 class="invalid-msg" >"You cannot make request, While your previous request was pending"</h5>
            </div>
            <div class="ml-3" style="gap:15px;">
              <div class="row"><h6>District: <b>{{PreviousAdd_PostReq[1]}}</b></h6></div>
              <div class="row"><h6>Applied Posting For: <b>{{PreviousAdd_PostReq[3]}}</b></h6></div>
              <div class="row"><h6>Applied Addtional Role: <b>{{PreviousAdd_PostReq[4]}}</b></h6></div>
              <div class="row"><h6>Status: <b>{{PreviousAdd_PostReq[5]}}</b></h6></div>
            </div>
            
          </div>
        </div>
      </ng-template>
  </div>
</div>


